import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getActiveUsers } from '../analytics.service';
import { InitialRetryDelay } from '../constants';
export const useActiveUsers = ({ subdomain = getSubdomain(), startDate, endDate, interval, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        ...options,
        queryKey: analyticsKeys.mostActiveUsers(subdomain, startDate, endDate, interval),
        queryFn: () => getActiveUsers(subdomain, startDate, endDate, interval),
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
